import L from 'leaflet';
import transparentImg from '../../icons/transparent.png';
import { Marker, Tooltip } from 'react-leaflet';
import { StyledAssetTotalTooltip } from '../../Styled';
import { observer } from 'mobx-react';
import { useMapStore } from 'contexts/RootStore.context';
import { BuildingFeature } from 'types/venue';

type AssetTotalCountProps = {
  buildingFeature: BuildingFeature;
};
export const AssetTotalCount = observer(({ buildingFeature }: AssetTotalCountProps) => {
  const {
    selectedBuildingId,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    assets, // this should be here to force re-render on changes of assets
    getBuidlingAssetsCount
  } = useMapStore()

  const displayPoint: any = [...buildingFeature.properties.display_point.coordinates].reverse(); // reversed to correct order
  const buildingIsSelected = selectedBuildingId === buildingFeature.id

  const customIcon = new L.Icon({
    iconUrl: transparentImg, // 1px alpha image to show nothing.
    iconSize: new L.Point(0, 0),
  });

  const buildingAssetCount = getBuidlingAssetsCount(buildingFeature.id)

  // only show tooltip if count is over 0
  // dont show if building is selected.
  return buildingAssetCount > 0 && !buildingIsSelected ? (
    <Marker icon={customIcon} position={displayPoint}>
      <Tooltip
        className="tooltip-asset-total"
        permanent
        opacity={1}
        direction="bottom"
        offset={[-25, 15]}
      >
        <StyledAssetTotalTooltip id={`assets-total-count-${buildingFeature.id}`}>
          {buildingAssetCount}
        </StyledAssetTotalTooltip>
      </Tooltip>
    </Marker>
  ) : null;
})